import { capitalize, isArray } from 'lodash/fp';
import { isZipValid, isPhoneValid } from '../utils/validation';

export const gettingStartedSelector = state => {
  const {
    reasons,
    rooms: planRooms,
    services,
    family,
    address,
    proPlatform,
  } = state.gettingStarted;
  const rooms = isArray(planRooms)
    ? planRooms
    : Object.keys(planRooms).map(p => ({ type: p, quantity: +planRooms[p] }));

  // const familyAdults = Object.values(family.adults);
  // const familyAdultsInvalid = familyAdults.some(adult => !adult.gender || !adult.age);
  // const familyChildren = Object.values(family.children);
  // const familyChildrenInvalid = familyChildren.some(child => !child.gender || !child.age);
  // const familyPets = Object.values(family.pets);
  // const familyPetsInvalid = familyPets.some(
  //   pet => !pet.type || (pet.type === 'other' && !pet.name),
  // );
  // const noFamilyMembers = !familyAdults.length && !familyChildren.length && !familyPets.length;
  // const noFamilyMembers = false;
  // const familyInvalid = familyAdultsInvalid || familyChildrenInvalid || familyPetsInvalid || noFamilyMembers

  const addressInvalid =
    Object.values(address).some(value => !(value || '').trim().length) ||
    !isPhoneValid(address.phone) ||
    !isZipValid(address.postcode);

  return {
    values: { reasons, rooms, services, family, address },
    form: {
      reasonsInvalid: !reasons.length,
      roomsInvalid: !rooms.length,
      servicesInvalid: !services.length,
      addressInvalid,
      familyAdultsInvalid: false,
      familyChildrenInvalid: false,
      familyPetsInvalid: false,
      familyInvalid: false,
    },
    proPlatform,
  };
};

export const gettingStartedPlanSelector = state => {
  const {
    rooms: planRooms,
    packages,
    prices,
    address,
    roomsOptions,
    packages_list: packagesOptions,
    plans_list: plansOptions,
  } = state.gettingStartedPlan;

  const rooms = Object.keys(planRooms).reduce((acct, key) => {
    const items = Array.from(Array(+planRooms[key]).keys());
    return [
      ...acct,
      ...items.map((_, idx) => ({
        name: `${key}_${idx + 1}`,
        key,
        index: idx,
        multipleOfSameType: items.length > 1,
      })),
    ];
  }, []);
  const roomsValues = isArray(planRooms)
    ? planRooms
    : Object.keys(planRooms).map(p => ({ type: p, quantity: +planRooms[p] }));

  const roomsPackagesOptions = rooms.map(({ name: room, key, index, multipleOfSameType }) => ({
    name: key,
    value: room,
    label: roomsOptions[key]
      ? capitalize(`${roomsOptions[key].label}${multipleOfSameType ? ` ${index + 1}` : ''}`)
      : room
          .split('_')
          .map(capitalize)
          .join(' '),
    selected: packages[room] && packages[room].plan,
    icon: roomsOptions[key] && roomsOptions[key].icon,
  }));

  const roomsDeliveryOptions = rooms.map(({ name: room, key, index, multipleOfSameType }) => ({
    name: key,
    value: room,
    label: roomsOptions[key]
      ? capitalize(`${roomsOptions[key].label}${multipleOfSameType ? ` ${index + 1}` : ''}`)
      : room
          .split('_')
          .map(capitalize)
          .join(' '),
    selected: packages[room] && packages[room].term,
    icon: roomsOptions[key] && roomsOptions[key].icon,
  }));

  const packageInvalid = rooms.some(
    ({ name: room }) => !packages[room] || (packages[room] && !packages[room].plan),
  );
  const deliveryInvalid = rooms.some(
    ({ name: room }) => !packages[room] || (packages[room] && !packages[room].term),
  );
  const addressInvalid =
    Object.values(address).some(value => !(value || '').trim().length) ||
    !isPhoneValid(address.phone) ||
    !isZipValid(address.postcode);

  return {
    roomsPackages: roomsPackagesOptions,
    roomsDelivery: roomsDeliveryOptions,
    packagesOptions: packagesOptions || [],
    plansOptions: plansOptions || [],
    prices,
    values: { packages, address, rooms: roomsValues },
    form: {
      packageInvalid,
      deliveryInvalid,
      addressInvalid,
    },
  };
};



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/store/selectors.js